export default __webpack_public_path__ + "static/media/menu.4d82f322.svg";